import { render, staticRenderFns } from "./PointsTable.vue?vue&type=template&id=4a0a455f&"
import script from "./PointsTable.vue?vue&type=script&lang=js&"
export * from "./PointsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports